import restCrudActions from '../../../np-crud/store/restCrudActions'

import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'CPU',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch cpu action creators

export const fetchCPUInit = () => {
    return crudActions.fetchInit();
};
export const fetchCPUStart = () => {
    return crudActions.fetchStart();
};
export const fetchCPUSuccess = (fetchCPUCount, listCPUCount) => {
    return crudActions.fetchSuccess(fetchCPUCount, listCPUCount);
};
export const fetchCPUFail = () => {
    return crudActions.fetchFail();
};


export const fetchCPUCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCPUStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchCPUSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchCPUFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch CPU."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchCPUFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch CPU."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchCPU = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchCPUStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchCPUSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchCPUFail());
            return []

        } catch (error) {
            dispatch(fetchCPUFail());
            return []
        }
    }
}

// Load cpu action creators
export const loadCPUInit = () => {
    return crudActions.loadInit();
};
export const loadCPUStart = () => {
    return crudActions.loadStart();
};
export const loadCPUSuccess = loadedCPU => {
    return crudActions.loadSuccess(loadedCPU);
};
export const loadCPUFail = error => {
    return crudActions.loadFail(error);
};
export const loadCPU = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create CPU  action creators
export const createCPUInit = () => {
    return crudActions.createInit();
};
export const createCPUStart = () => {
    return crudActions.createStart();
};
export const createCPUSuccess = createdCPU => {
    return crudActions.createSuccess(createdCPU);
};
export const createCPUFail = error => {
    return crudActions.createFail(error);
};

export const createCPU = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createCPUStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createCPUSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created CPU.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createCPUFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create CPU."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create CPU."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createCPUFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit CPU  action creators
export const editCPUInit = () => {
    return crudActions.editInit();
};
export const editCPUStart = () => {
    return crudActions.editStart();
};
export const editCPUSuccess = editedCPU => {
    return crudActions.editSuccess(editedCPU);
};
export const editCPUFail = error => {
    return crudActions.editFail(error);
};
export const editCPU = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editCPUStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editCPUSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated CPU.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editCPUFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit CPU."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit CPU."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editCPUFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete cpu action creators
export const bulkDeleteCPUsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteCPUsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteCPUsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteCPUsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteCPUs = cpuIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, cpuIds);
    };
};

// Delete cpu  action creators
export const deleteCPUInit = () => {
    return crudActions.deleteInit();
};
export const deleteCPUStart = () => {
    return crudActions.deleteStart();
};
export const deleteCPUSuccess = deletedCPU => {
    return crudActions.deleteSuccess(deletedCPU);
};
export const deleteCPUFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteCPU = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};
export const setCpus = (data) => {
    return ({
        type: 'HANDLE_CPUS',
        cpus: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
